import { TranslateService } from '@ngx-translate/core';

export function createGeoAreasPopupTemplate(translate: TranslateService) {
    const popupTemplate = {
        title: translate.instant('iaa.map.geoAreasLayer'),
        content: (feature: any) => {
            const attributes = feature.graphic.attributes;
            
            const currentLang = translate.currentLang || translate.getDefaultLang();
            const nafaName = currentLang === 'en' ? (attributes.nafanameeng || attributes.nafaname) : attributes.nafaname;
            
            if (!nafaName) {
                return '<p>No information available</p>';
            }
            
            return `<div style="text-align: center; padding: 10px;">
                <strong>${nafaName}</strong>
            </div>`;
        },
        lastEditInfoEnabled: false
    };
    return popupTemplate;
}
